import 'bootstrap'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import global from './global'
import './registerServiceWorker'
import '../public/assets/animate.css/animate.min.css'
import '../public/assets/glyphicons/glyphicons.css'
import '../public/assets/font-awesome/css/font-awesome.min.css'
import '../public/assets/material-design-icons/material-design-icons.css'
import '../public/assets/bootstrap/dist/css/bootstrap.css'
import '../public/assets/styles/app.css'
import '../public/assets/styles/font.css'

Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper)
Vue.prototype.GLOBAL = global
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
